import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

// Closing CTA inspired by the "Your next breakthrough starts here" reference.
// Re-mapped to navy + gold palette.
export default function BreakthroughCTA({
    kicker = "Get started",
    heading = "Your next breakthrough starts here.",
    blurb = "Move forward with clarity and confidence, backed by an independent partner that puts you first.",
    primaryHref = "/contact",
    primaryLabel = "Contact us",
    secondaryHref,
    secondaryLabel,
}) {
    return (
        <section className="section container-page" data-testid="breakthrough-cta">
            <div className="relative max-w-4xl mx-auto text-center">
                <p className="overline mb-4 text-brand-amber">{kicker}</p>
                <h2 className="display text-5xl md:text-6xl lg:text-7xl text-brand-ink leading-[1.02]">
                    {heading}
                </h2>
                <p className="mt-7 max-w-2xl mx-auto text-brand-ink/75 text-lg leading-relaxed">
                    {blurb}
                </p>
                <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
                    <Link to={primaryHref} className="btn-accent" data-testid="breakthrough-primary">
                        {primaryLabel} <ArrowUpRight size={16} />
                    </Link>
                    {secondaryHref && (
                        <Link to={secondaryHref} className="btn-ghost" data-testid="breakthrough-secondary">
                            {secondaryLabel}
                        </Link>
                    )}
                </div>
                <span className="ornament mx-auto mt-12 block max-w-[120px]" aria-hidden="true" />
            </div>
        </section>
    );
}
